import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../../shared/translate/translate.service';
import { RoleAvailabilityModel } from '../models/roleavailability.model';
import { IKeyValueInterface } from '../../shared/config';
import { RoleAvailabilityService } from '../models/roleavailability.service';
import { AuthService } from '../../shared/models/auth.service';

@Component({
  selector: 'wego-roleavailability-update-popup',
  template: require('../views/roleavailability-update-popup.component.html'),
  providers: [RoleAvailabilityService]
})

export class RoleAvailabilityPopupComponent implements OnInit, OnDestroy {
  ErrorMsg: string = '';
  _model: RoleAvailabilityModel;
  errorModel: IKeyValueInterface[] = [];
  _popupTitle: string = this.translate.instant('LblRoleAvailability');

  @ViewChild('UpdateRoleAvailabilityModal') public UpdateRoleAvailabilityModal: ModalDirective;

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblRoleAvailability');
  }
  get popupTitle() { return this._popupTitle; }

  @Input()
  set model(model: RoleAvailabilityModel) {
    this._model = model;
  }
  get model() { return this._model; }

  @Output('onConfirm') onConfirm = new EventEmitter();
  @Output('onCancel') onCancel = new EventEmitter();

  constructor(private translate: TranslateService
    , private roleAvailabilityService: RoleAvailabilityService
    , private authService: AuthService) {
  }

  ngOnInit() {
  }

  public show() {
    this.ErrorMsg = "";
    this.errorModel = [];
    this.UpdateRoleAvailabilityModal.show();
  }

  public hide() {
    this.UpdateRoleAvailabilityModal.hide();
  }

  private Confirm($event: any) {
    this.roleAvailabilityService.UpdateRoleAvailability(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.hide();
          this.onConfirm.emit();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.ErrorMsg = this.authService.HandleErrorStatusCode(error);
      });
  }

  private Reject($event: any) {
    this.hide();
    this.onCancel.emit($event);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/roleavailability/components/roleavailability-update-popup.component.ts